import React from "react"

import { W0, W1 } from "@components/constants"


const FormNavigationFooter = ({ children }) => {
  return (
    <div style={{
      gap: W1,
      width: "100%",
      display: "flex",
      marginBottom: W0,
      justifyContent: "space-between",
    }}>
      {children}
    </div>
  )
}

export default FormNavigationFooter
